import { render } from "./detail-siswa.vue?vue&type=template&id=4a4ebd39&ts=true"
import script from "./detail-siswa.vue?vue&type=script&lang=ts"
export * from "./detail-siswa.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2652442822/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__